<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-entity-group-by-report-criteria [showEmployeeOption]="true"></wbo-entity-group-by-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-entity-sub-group-by-report-criteria [showOutletOption]="showOutletOption"></wbo-entity-sub-group-by-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-detail-report-criteria></wbo-detail-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row>
                <wbo-employee-report-selection></wbo-employee-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
